import { render, staticRenderFns } from "./tab-menu.html?vue&type=template&id=0e8a561a&scoped=true&"
import script from "./tab-menu.js?vue&type=script&lang=js&"
export * from "./tab-menu.js?vue&type=script&lang=js&"
import style0 from "./tab-menu.scss?vue&type=style&index=0&id=0e8a561a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8a561a",
  null
  
)

export default component.exports